import { createStyles } from '@mantine/core';
import { getTypographyStyles } from "src/theme/themeConfig";

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    contentContainer: {
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      paddingTop: "0",
    },
    inputError: {
      color: "red",
    },
    inputDescription: {
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "18px",
      color: "#8C8C8C",
      marginTop: "8px",
    },
    changeNumberLink: {
      color: "gray",
      border: "none",
      padding: "0px",
      backgroundColor: "transparent",
      outline: "none",
      width: "auto",
      textAlign: "left",
      fontSize: "12px",
      ":hover": {
        color: "#1DBBF0",
        cursor: "pointer",
      },
    },
    button: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "12px",
      gap: "10px",
      width: "118px",
      background: "#EB2F96",
      borderRadius: "5px",
      border: "none",
      color: "#ffffff",
      ":hover": {
        cursor: "pointer",
      },
    },
    footer: {
      display: "flex",
      justifyContent: "flex-end !important",
      alignItems: "center",
      marginRight: "auto",
    },
    backButtonWrapper: {
      position: "absolute",
      top: 16,
      left: 16,
      zIndex: 99,
    },
    // esign new buttons
    buttonWBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px 12px",
      gap: "10px",
      borderRadius: "8px",
      fontSize: "14px",
      marginBottom: "10px",
      backgroundColor: colors.base.white,
      color: colors.fg.default,
      border: `1px solid ${colors.disabled.muted}`,
      transition: "0.2s",
      width: "100%",
      ...getTypographyStyles("heading_2xs_semibold"),
      ":hover": {
        cursor: "pointer",
        backgroundColor: colors.primary.muted,
        color: colors.primary.default,
        border: `1px solid ${colors.primary.subtle}`,
      },
    },
    buttonSelectedAdditionalStyles: {
      cursor: "pointer",
      backgroundColor: colors.primary.muted,
      color: colors.primary.default,
      border: `1px solid ${colors.primary.subtle}`,
    },
    checkBoxBody: {
      display: "flex",
      justifyContent: "flex-start",
      width: "400px",
      alignItems: 'center',
    },
    checkBoxLabel: {
      ...getTypographyStyles("heading_2xs_semibold"),
      paddingLeft: 16,
    },
    labelWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
    },
    innerLabelWrapper: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    optionsWrapper: {
      display: "flex",
      flexWrap: "wrap",
      width: "100%",
      justifyContent: "space-between",
      marginTop: "20px",
    },
    adhaarSecCtaLink: {
      color: "#1DBBF0",
      border: "none",
      padding: "0px",
      backgroundColor: "transparent",
      outline: "none",
      width: "auto",
      textAlign: "left",
      fontSize: "12px",
      marginTop: "auto",
      ":hover": {
        color: "#1d87f0",
        cursor: "pointer",
      },
    },
  };
});

export default useStyles;
